import { render, staticRenderFns } from "./welfare-goods.vue?vue&type=template&id=76f56bce&scoped=true&"
import script from "./welfare-goods.vue?vue&type=script&lang=js&"
export * from "./welfare-goods.vue?vue&type=script&lang=js&"
import style0 from "./welfare-goods.vue?vue&type=style&index=0&id=76f56bce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f56bce",
  null
  
)

export default component.exports